<template>
  <div>
    <v-row>
      <v-col cols="12">

        <div style="float: left" class="pt-1"><h4 style="padding-top: 15px;">Situação Proposta</h4></div>
        <div style="float: right">
          <v-text-field
            v-model="proposalSituation.networkOpening"
            label="Abertura de Rede"
            outlined
            dense
          ></v-text-field>
        </div>
        <div class="pt-11"></div>
        <v-divider class="mb-4"></v-divider>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col class="pt-0" cols="2">
        <v-select
          :items="coparticipationMeasures"
          return-object
          item-value="id"
          item-text="description"
          v-model="proposalSituation.coparticipation.measure"
          label="Coparticipação"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-text-field
          v-model="proposalSituation.coparticipation.value"
          label="Valor 1ª Coparticipação"
          outlined
          dense
          v-if="proposalSituation.coparticipation.measure=='R$'"
        ></v-text-field>
        <v-select :items="coparticipationValues" return-object item-value="id" item-text="description" v-model="proposalSituation.coparticipation.value"
                  label="Valor 1ª Coparticipação" outlined dense
          v-else-if="proposalSituation.coparticipation.measure=='%'"
        ></v-select>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-select
          :items="coparticipationTypes"
          return-object
          item-value="id"
          item-text="description"
          v-model="proposalSituation.coparticipation.type"
          v-if="
            proposalSituation.coparticipation.value != null &&
            proposalSituation.coparticipation.value != '0'
          "
          label="Tipo de Coparticipação"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-select
          :items="coparticipationMeasures"
          return-object
          item-value="id"
          item-text="description"
          v-model="proposalSituation.secondCoparticipation.measure"
          label="Coparticipação"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-text-field
          v-model="proposalSituation.secondCoparticipation.value"
          label="Valor 2ª Coparticipação"
          outlined
          dense
          v-if="proposalSituation.secondCoparticipation.measure=='R$'"
        ></v-text-field>
        <v-select :items="coparticipationValues" return-object item-value="id" item-text="description" v-model="proposalSituation.secondCoparticipation.value"
                  label="Valor 2ª Coparticipação" outlined dense
                  v-else-if="proposalSituation.secondCoparticipation.measure=='%'"
        ></v-select>
      </v-col>
      <v-col class="pt-0" cols="2">
        <v-select
          :items="coparticipationTypes"
          return-object
          item-value="id"
          item-text="description"
          v-model="proposalSituation.secondCoparticipation.type"
          v-if="
            proposalSituation.secondCoparticipation.value != null &&
            proposalSituation.secondCoparticipation.value != '0'
          "
          label="Tipo da Segunda Coparticipação"
          outlined
          dense
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.coparticipation.consultationDesign"
          label="Desenho de Coparticipação - Consultas"
          outlined
          dense
        ></v-textarea>
      </v-col>
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.secondCoparticipation.consultationDesign"
          label="Desenho de Coparticipação - Consultas"
          outlined
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.coparticipation.consultationPSDesign"
          label="Desenho de Coparticipação - Cons. PS"
          outlined
          dense
        ></v-textarea>
      </v-col>
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.secondCoparticipation.consultationPSDesign"
          label="Desenho de Coparticipação - Cons. PS"
          outlined
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.coparticipation.examsDesign"
          label="Desenho de Coparticipação - Exames"
          outlined
          dense
        ></v-textarea>
      </v-col>
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.secondCoparticipation.examsDesign"
          label="Desenho de Coparticipação - Exames"
          outlined
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.coparticipation.otherDesigns"
          label="Desenho de Coparticipação - Outros"
          outlined
          dense
        ></v-textarea>
      </v-col>
      <v-col cols="6" class="pt-0">
        <v-textarea
          rows="3"
          v-model="proposalSituation.secondCoparticipation.otherDesigns"
          label="Desenho de Coparticipação - Outros"
          outlined
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="pt-0 pb-0">
        <v-checkbox
          label="Manutenção do modelo atual"
          class="mt-0"
          v-model="proposalSituation.withoutCurrentSituation"
          outlined
          dense
        ></v-checkbox>
      </v-col>
      <v-col cols="6" align="right" justify="end" class="pt-0 pb-0">
        <v-checkbox
          label="Não Utilizar Estratégia"
          style="width: 220px"
          v-model="proposalSituation.specific"
          class="mt-0"
          outlined
          dense
        ></v-checkbox>
      </v-col>
    </v-row>

    <!-- ################ Configuração de Planos ################# -->
    <v-tabs v-model="proposalSituationScenariosTab">
      <v-tab
        class="primary--text"
        :href="'#tab-' + (index + 1)"
        v-for="(scenario, index) in proposalSituation.scenarios"
        :key="'tab-' + (index + 1)"
      >
        CENÁRIO {{ index + 1 }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="proposalSituationScenariosTab">
      <v-tab-item
        :value="'tab-' + (index + 1)"
        v-for="(scenario, index) in proposalSituation.scenarios"
        :key="'tab-' + (index + 1)"
      >
        <v-row class="pt-5">
          <v-col cols="4">
            <v-select
              :items="regions"
              v-model="scenario.carrierCurrentPlans.regions"
              label="Região - Comparativo de Rede"
              return-object
              item-value="id"
              item-text="name"
              @change="findAllReferenceCarriersByBenefitIdAndRegion"
              :loading="regions.length == 0"
              dense
              outlined
              chips
              multiple
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              :items="regions"
              v-model="scenario.carrierCurrentPlans.mainRegion"
              label="Região Principal"
              return-object
              item-value="id"
              item-text="name"
              :loading="regions.length == 0"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col>
            <v-checkbox
              class="mt-0"
              v-model="proposalSituation.showInactiveLives"
              @change="resetInactives"
              label="Adicionar Inativos"
              v-if="placementPermission"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              class="mt-0"
              v-model="proposalSituation.showHouseHoldLives"
              @change="resetHouseHoldies"
              label="Adicionar Agregados"
              v-if="placementPermission"
            ></v-checkbox>
          </v-col>
          <v-col align="right" justify="end">
            <v-btn small @click="findPrices" v-if="placementPermission">
              <v-icon small left>fas fa-search</v-icon>
              Buscar Preços </v-btn
            >&nbsp;
          </v-col>
        </v-row>
        <div
          style="
            width: 100%;
            height: 100%;
            overflow-x: auto;
            overflow-y: hidden;
          "
        >
          <table style="width: 100%">
            <tr>
              <td style="width: 345px">
                <v-col> Operadora Atual </v-col>
              </td>
              <td
                :style="'width: ' + item.width + 'px'"
                v-for="(item, is) in scenario.carrierProposedPlans"
              >
                <v-col class="mb-0 pb-0" :style="'width: ' + item.width + 'px'">
                  Operadora
                  {{ item.isReferencedCarrier ? 'Referência' : 'Proposta' }}
                  <div style="float: right">
                    <v-checkbox
                      label="ADM"
                      v-model="item.adm"
                      class="mt-0"
                    ></v-checkbox>
                  </div>
                </v-col>
              </td>
            </tr>
            <tr>
              <td>
                <v-col class="pt-0 pb-0">
                  {{ scenario.carrierCurrentPlans.carrier.comercialName }}<br />
                  <v-btn icon small @click="showNotes = !showNotes">
                    <v-icon small>{{
                      showNotes ? 'fas fa-minus' : 'fas fa-plus'
                    }}</v-icon>
                  </v-btn>
                  Exibir Observações
                </v-col>
              </td>
              <td v-for="(item, is) in scenario.carrierProposedPlans">
                <v-col class="mt-0 pt-0" :style="'width: ' + item.width + 'px'">
                  <v-select
                    v-if="item.isReferencedCarrier"
                    :items="referenceCarriers"
                    v-model="item.carrier"
                    return-object
                    item-value="id"
                    item-text="comercialName"
                    @change="requestReferencePlans(item)"
                    clearable
                    :loading="referenceCarriers.length == 0"
                    dense
                    outlined
                  ></v-select>

                  <v-select
                    v-else
                    :items="equivalenceCarriers"
                    v-model="item.carrier"
                    return-object
                    clearable
                    item-value="id"
                    item-text="comercialName"
                    @change="requestEquivalentPlansByCarrier(item,is)"
                    :loading="equivalenceCarriers.length == 0"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </td>
            </tr>
            <tr v-if="showNotes">
              <td>
                <v-col class="pt-2">
                  <v-textarea
                    v-model="scenario.carrierCurrentPlans.notes"
                    outlined
                    dense
                    label="Observação"
                  ></v-textarea>
                </v-col>
              </td>
              <td v-for="(item, is) in scenario.carrierProposedPlans">
                <v-col class="pt-2">
                  <v-textarea
                    v-model="item.notes"
                    outlined
                    dense
                    label="Observação"
                  ></v-textarea>
                </v-col>
              </td>
            </tr>

            <tr v-for="(plan, index) in scenario.carrierCurrentPlans.plans">
              <td colspan="5">
                <table style="width: 100%">
                  <tr>
                    <td>
                      <v-col>
                        Plano Atual
                        <v-icon
                          x-small
                          @click="copyCurrentPlan(index)"
                          v-if="!plan.copy"
                          >fas fa-plus</v-icon
                        >
                        <v-icon x-small @click="removeCurrentPlan(index)" v-else
                          >fas fa-times</v-icon
                        >
                      </v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col
                              :style="
                                item.width != '345' &&
                                item.plans[index].linedPlans.length == 1
                                  ? 'width: ' + item.width + 'px'
                                  : 'width: 345px'
                              "
                            >
                              <div style="width: 320px">
                                Plano
                                {{
                                  item.isReferencedCarrier
                                    ? 'Referência'
                                    : 'Proposto'
                                }}
                                <v-icon
                                  x-small
                                  @click="addProposalPlan(item, index)"
                                  v-if="lpi == 0"
                                  >fas fa-plus</v-icon
                                >
                                <v-icon
                                  x-small
                                  @click="removeProposalPlan(item, index, lpi)"
                                  v-else
                                  >fas fa-times</v-icon
                                >
                                <div
                                  style="float: right"
                                  v-if="item.isReferencedCarrier"
                                >
                                  <UpgradeDowngradePlanDialog
                                    :plansType="item.plansType"
                                    :plan="linedItem.product"
                                    :is-upgrade="true"
                                    :upgrade-downgrade="linedItem.upgradePlans"
                                  ></UpgradeDowngradePlanDialog>
                                  <UpgradeDowngradePlanDialog
                                    :plansType="item.plansType"
                                    :plan="linedItem.product"
                                    :is-upgrade="false"
                                    :upgrade-downgrade="
                                      linedItem.downgradePlans
                                    "
                                  ></UpgradeDowngradePlanDialog>
                                </div>
                                <div style="float: right" v-else>
                                  <UpgradeDowngradePlanDialog
                                    :plansType="item.plans[index].plansType"
                                    :plan="linedItem.product"
                                    :is-upgrade="true"
                                    :upgrade-downgrade="linedItem.upgradePlans"
                                  ></UpgradeDowngradePlanDialog>
                                  <UpgradeDowngradePlanDialog
                                    :plansType="item.plans[index].plansType"
                                    :plan="linedItem.product"
                                    :is-upgrade="false"
                                    :upgrade-downgrade="
                                      linedItem.downgradePlans
                                    "
                                  ></UpgradeDowngradePlanDialog>
                                </div>
                              </div>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <v-col style="width: 345px; font-weight: bold">
                        {{ plan.product.productCode }} -
                        {{ plan.product.description }}&nbsp;
                      </v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-select
                                :items="item.plans[index].plansType"
                                v-model="linedItem.product"
                                return-object
                                clearable
                                item-value="id"
                                item-text="name"
                                @change="
                                  getEquivalentsCarriers(linedItem,index,plan);
                                "
                                v-if="item.isReferencedCarrier"
                                :loading="item.plans[index].plansType == 0"
                                dense
                                outlined
                              ></v-select>
                              <v-select
                                :items="item.plans[index].plansType"
                                v-model="linedItem.product"
                                v-else
                                clearable
                                return-object
                                item-value="id"
                                item-text="name"
                                :loading="
                                  item.plans[index].plansType.length == 0
                                "
                                @change="getEquivalentsPlans(index,plan)"                                
                                dense
                                outlined
                              ></v-select>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                        <v-row>  
                        <v-col cols="6" class="pt-1 pb-0"> Consulta </v-col>
                          <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="plan.consultationRefund"
                              v-mask="$util.formmasks.money"
                              label="Reembolso"
                              outlined
                              dense
                              readonly
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px" class="pt-0 pb-0">
                              <v-text-field
                                v-model="linedItem.consultationRefund"
                                v-mask="$util.formmasks.money"
                                label="Reembolso"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                        <v-row>
                          <v-col cols="6" class="pt-0 pb-0">
                            Sessão de Psicoterapia
                          </v-col>
                          <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="plan.psychotherapyRefund"
                              v-mask="$util.formmasks.money"
                              label="Reembolso"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px" class="pt-0 pb-0">
                              <v-text-field
                                v-model="linedItem.psychotherapyRefund"
                                v-mask="$util.formmasks.money"
                                label="Reembolso"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                        <v-row>
                          <v-col cols="6" class="pt-0 pb-0">
                            Fisioterapia
                          </v-col>
                          <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="plan.physiotherapyRefund"
                              v-mask="$util.formmasks.money"
                              label="Reembolso"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px" class="pt-0 pb-0">
                              <v-text-field
                                v-model="linedItem.physiotherapyRefund"
                                v-mask="$util.formmasks.money"
                                label="Reembolso"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                        <v-row>
                          <v-col cols="6" class="pt-0 pb-0">
                            Tomografia de Crânio</v-col
                          >
                          <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="plan.skullTomographyRefund"
                              v-mask="$util.formmasks.money"
                              label="Reembolso"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px" class="pt-0 pb-0">
                              <v-text-field
                                v-model="linedItem.skullTomographyRefund"
                                v-mask="$util.formmasks.money"
                                label="Reembolso"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                        <v-row>
                          <v-col cols="6" class="pt-1 pb-0">
                            Parto Cesária</v-col
                          >
                          <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="plan.caesareanBirthRefund"
                              v-mask="$util.formmasks.money"
                              label="Reembolso"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px" class="pt-0 pb-0">
                              <v-text-field
                                v-model="linedItem.caesareanBirthRefund"
                                v-mask="$util.formmasks.money"
                                label="Reembolso"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                        <v-row>
                          <v-col cols="6" class="pt-0 pb-0"
                            >Revasc. do Miocárdio</v-col
                          >
                          <v-col cols="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="plan.revascularizationMyocardiumRefund"
                              v-mask="$util.formmasks.money"
                              label="Reembolso"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px" class="pt-0 pb-0">
                              <v-text-field
                                v-model="
                                  linedItem.revascularizationMyocardiumRefund
                                "
                                v-mask="$util.formmasks.money"
                                label="Reembolso"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <!-- Vidas Ativas -->
                  <tr v-if="placementPermission">
                    <td>
                      <v-col style="width: 345px">
                          <v-col cols="12" class="pt-0 pb-0">
                              <v-text-field
                                      v-model="plan.lives"
                                      v-mask="$util.formmasks.number"
                                      label="Vidas"
                                      outlined
                                      dense
                                      readonly
                              ></v-text-field>
                          </v-col>
                      </v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0"></v-col>
                                <v-col class="pt-0 text-center">
                                  Co-part
                                </v-col>
                                <v-col class="pt-0 text-center">
                                  2a. Co-part
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="placementPermission">
                    <td>
                      <v-col style="width: 345px">
                        <v-row>
                          <v-col cols="8">
                            <v-switch
                              class="mt-0 switch-base"
                              v-model="plan.openAgeGroupCost"
                              :label="`Custo por Faixa Etária`"
                              dense
                            ></v-switch>
                          </v-col>
                          <v-col align="right" justify="end" class="mt-1">
                            Vidas Ativas
                          </v-col>
                        </v-row>
                      </v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="linedItem.lives"
                                    v-mask="$util.formmasks.number"
                                    label="Vidas"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="linedItem.copay.averageCost"
                                    v-mask="$util.formmasks.money"
                                    label="Custo Médio"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="linedItem.secondCopay.averageCost"
                                    v-mask="$util.formmasks.money"
                                    label="Custo Médio"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px"></v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0" style="text-align: center"
                                  >Vidas</v-col
                                >
                                <v-col class="pt-0" style="text-align: center"
                                  >Valor</v-col
                                >
                                <v-col class="pt-0" style="text-align: center"
                                  >Valor</v-col
                                >
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >Até 18 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[0].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[0].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[0].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >19 até 23 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[1].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[1].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[1].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >24 até 28 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[2].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[2].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[2].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >29 até 33 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[3].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[3].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[3].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >34 até 38 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[4].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[4].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[4].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >39 até 43 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[5].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[5].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[5].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >44 até 48 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[6].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[6].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[6].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >49 até 53 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[7].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[7].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[7].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >54 até 58 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[8].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[8].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[8].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index].openAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >A partir de 59 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="linedItem.ageGroupCost[9].lives"
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[9].copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.ageGroupCost[9].secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <!-- Vidas Inativas -->
                  <tr v-if="proposalSituation.showInactiveLives">
                    <td>
                      <v-col style="width: 345px"></v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0"></v-col>
                                <v-col class="pt-0 text-center">
                                  Co-part
                                </v-col>
                                <v-col class="pt-0 text-center">
                                  2a. Co-part
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="proposalSituation.showInactiveLives">
                    <td>
                      <v-col style="width: 345px">
                        <v-row>
                          <v-col cols="8">
                            <v-switch
                              class="mt-0 switch-base"
                              v-model="plan.openInactiveAgeGroupCost"
                              :label="`Custo por Faixa Etária`"
                              dense
                              @change="resetInactives"
                            ></v-switch>
                          </v-col>
                          <v-col align="right" justify="end" class="mt-1">
                            Vidas Inativas
                          </v-col>
                        </v-row>
                      </v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="linedItem.inactiveLives"
                                    label="Vidas"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveCopay.averageCost
                                    "
                                    v-mask="$util.formmasks.money"
                                    label="Custo Médio"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveSecondCopay.averageCost
                                    "
                                    v-mask="$util.formmasks.money"
                                    label="Custo Médio"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px"></v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0" style="text-align: center"
                                  >Vidas</v-col
                                >
                                <v-col class="pt-0" style="text-align: center"
                                  >Valor</v-col
                                >
                                <v-col class="pt-0" style="text-align: center"
                                  >Valor</v-col
                                >
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >Até 18 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[0].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[0]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[0]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >19 até 23 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[1].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[1]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[1]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >24 até 28 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[2].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[2]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[2]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >29 até 33 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[3].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[3]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[3]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >34 até 38 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[4].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[4]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[4]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >39 até 43 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[5].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[5]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[5]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >44 até 48 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[6].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[6]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[6]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >49 até 53 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[7].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[7]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[7]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >54 até 58 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[8].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[8]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[8]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openInactiveAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >A partir de 59 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[9].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[9]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.inactiveAgeGroupCost[9]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <!-- Vidas Agregados -->
                  <tr v-if="proposalSituation.showHouseHoldLives">
                    <td>
                      <v-col style="width: 345px"></v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0"></v-col>
                                <v-col class="pt-0 text-center">
                                  Co-part
                                </v-col>
                                <v-col class="pt-0 text-center">
                                  2a. Co-part
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr v-if="proposalSituation.showHouseHoldLives">
                    <td>
                      <v-col style="width: 345px">
                        <v-row>
                          <v-col cols="8">
                            <v-switch
                              class="mt-0 switch-base"
                              v-model="plan.openHouseHoldAgeGroupCost"
                              :label="`Custo por Faixa Etária`"
                              dense
                              @change="resetHouseHoldies"
                            ></v-switch>
                          </v-col>
                          <v-col align="right" justify="end" class="mt-1">
                            Vidas Agregados
                          </v-col>
                        </v-row>
                      </v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="linedItem.houseHoldLives"
                                    label="Vidas"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldCopay.averageCost
                                    "
                                    v-mask="$util.formmasks.money"
                                    label="Custo Médio"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldSecondCopay.averageCost
                                    "
                                    v-mask="$util.formmasks.money"
                                    label="Custo Médio"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px"></v-col>
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0" style="text-align: center"
                                  >Vidas</v-col
                                >
                                <v-col class="pt-0" style="text-align: center"
                                  >Valor</v-col
                                >
                                <v-col class="pt-0" style="text-align: center"
                                  >Valor</v-col
                                >
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >Até 18 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[0].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[0]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[0]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >19 até 23 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[1].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[1]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[1]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >24 até 28 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[2].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[2]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[2]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >29 até 33 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[3].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[3]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[3]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >34 até 38 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[4].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[4]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[4]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >39 até 43 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[5].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[5]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[5]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >44 até 48 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[6].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[6]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[6]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >49 até 53 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[7].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[7]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[7]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >54 até 58 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[8].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[8]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[8]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      scenario.carrierCurrentPlans.plans[index]
                        .openHouseHoldAgeGroupCost
                    "
                  >
                    <td>
                      <v-col style="width: 345px; text-align: right"
                        >A partir de 59 anos</v-col
                      >
                    </td>
                    <td
                      style="width: 20%"
                      v-for="(item, is) in scenario.carrierProposedPlans"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            v-for="(linedItem, lpi) in item.plans[index]
                              .linedPlans"
                          >
                            <v-col style="width: 345px">
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[9].lives
                                    "
                                    v-mask="$util.formmasks.number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[9]
                                        .copayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                  <v-text-field
                                    v-model="
                                      linedItem.houseHoldAgeGroupCost[9]
                                        .secondCopayValue
                                    "
                                    v-mask="$util.formmasks.money"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <v-divider></v-divider>
              </td>
            </tr>
          </table>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-row class="mt-4" v-if="placementPermission">
      <v-col cols="12" class="pt-0">
        <vue-editor
          id="editorConsolidatedNote"
          v-model="proposalSituation.financialConsolidatedNote"
          :placeholder="'Nota Consolidado Financeiro'"
          :editor-toolbar="customToolbar"
        />
      </v-col>
    </v-row>
    <v-row class="mt-4" v-if="placementPermission">
      <v-col cols="12" class="pt-0">
        <vue-editor
          id="editorGroupCostNote"
          v-model="proposalSituation.ageGroupCostNote"
          :placeholder="'Nota Custo Faixa Etária'"
          :editor-toolbar="customToolbar"
        />
      </v-col>
    </v-row>
    <v-row class="mt-4" v-if="placementPermission">
      <v-col cols="12" class="pt-0">
        <vue-editor
          id="editorComparisonNote"
          v-model="proposalSituation.financialComparisonNote"
          :placeholder="'Nota Comparativo Financeiro'"
          :editor-toolbar="customToolbar"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Title from '@/components/structure/title';
import ProductService from '@/services/odoo/ProductService';
import CarrierService from '@/services/odoo/CarrierService';
import UpgradeDowngradePlanDialog from '@/view/study/dialog/dlg_upgrade_downgrade_plan';
import RegionService from '@/services/odoo/RegionService';
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';
import {VueEditor} from 'vue2-editor';

export default {
  components: {UpgradeDowngradePlanDialog, Title, VueEditor},
  props: {
    proposalSituation: {
      type: Object,
    },
    account: {
      type: Object,
    },
    benefit: {
      type: Object,
    },
    findPrices: Function,
    studyConfiguration: {
      type: Object,
    },
    placementPermission: {
      type: Boolean,
    },
  },
  data() {
    return {
      coparticipationValues: ["0","10","20","30","40","50"],
      coparticipationMeasures: ['R$', '%'],
      coparticipationTypes: [
        {id: 2, description: 'Revertido para a Empresa'},
        {id: 3, description: 'Revertido para a Operadora'},
      ],
      proposalSituationScenariosTab: null,
      regions: [],
      showNotes: false,
      referenceCarriers: [],
      equivalenceCarriers: [],
      referencePlans: [],
      equivalencePlans: [],
      customToolbar: [
        [
          {
            size: ['small', false, 'large', 'huge'],
          },
        ],
        ['bold'],
        [{color: []}],
      ],
    };
  },
  async created() {
    this._productService = new ProductService();
    this._carrierService = new CarrierService();
    this._regionsService = new RegionService();
    this._equivalenceConfigurationService =
      new EquivalenceConfigurationService();
  },
  mounted() {
    this.getRegions();
    this.findAllReferenceCarriersByBenefitIdAndRegion();
  },
  methods: {
    async getRegions() {
      if (this.regions.length == 0) {
        const {data} = await this._regionsService.findAllActivated();
        this.regions = data;
      }
    },
    activeDeactivateAgeGroupCost(indexPlan) {
      if (
        this.proposalSituation.scenarios[0].carrierCurrentPlan.plans[indexPlan]
          .openAgeGroupCost
      ) {
        this.addAgeCostStructure(indexPlan);
      } else {
        this.removeAgeCostStructure(indexPlan);
      }
    },
    addAgeCostStructure(index) {
      for (let i = 0; i < 10; i++) {
        this.proposalSituation.scenarios[0].carrierProposedPlan.plans[
          index
        ].ageGroupCost.push(
          {
            lives: null,
            copayAverageCost: null,
            secondCopayAverageCost: null,
          },
          i,
        );
      }
    },
    removeAgeCostStructure(index) {
      this.proposalSituation.scenarios[0].carrierProposedPlan.plans[
        index
      ].ageGroupCost = {};
    },
    async findAllReferenceCarriersByBenefitIdAndRegion() {
      this.referenceCarriers =
        await this._equivalenceConfigurationService.findAllReferenceCarriersByRegionAndBenefit(
          this.proposalSituation.scenarios[0].carrierCurrentPlans.regions,
          this.benefit.id,
          this.studyConfiguration.id,
          this.getAllCurrentPlans(),
          this.proposalSituation.specific,
        );
      this.referenceCarriers = this.referenceCarriers.data;

      this.findAllEquivalentCarriersByBenefitIdAndRegionAndReferencePlanId();
    },
    async findAllEquivalentCarriersByBenefitIdAndRegionAndReferencePlanId() {
      this.equivalenceCarriers =
        await this._equivalenceConfigurationService.findAllEquivalentCarriersByRegionAndBenefit(
          this.proposalSituation.scenarios[0].carrierCurrentPlans.regions,
          this.getAllReferencePlans(),
          this.benefit.id,
          this.studyConfiguration.id,
          this.getAllCurrentPlans(),
          this.proposalSituation.specific,
        );
      this.equivalenceCarriers = this.equivalenceCarriers.data;
    },
    async requestReferencePlans(item) {
      
      if(!item.carrier || !item.carrier.id){
        this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.forEach((p,pIndex) => {
          item.plans[pIndex].plansType = [];
          item.plans[pIndex].linedPlans.forEach(l => {
            l.product = null;
            l.consultationRefund = null;
            l.psychotherapyRefund = null;
            l.physiotherapyRefund = null;
            l.skullTomographyRefund = null;
            l.caesareanBirthRefund = null;
            l.revascularizationMyocardiumRefund = null;
          });
        });
        return;
      }

      let currentPlanIds = [];
      for (
        var i = 0;
        i <
        this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.length;
        i++
      ) {
        let planId =
          this.proposalSituation.scenarios[0].carrierCurrentPlans.plans[i]
            .product.id;
        currentPlanIds.splice(0);
        if (planId != null) {
          currentPlanIds.push(planId);
        }
        await this._equivalenceConfigurationService
          .findAllReferencePlansByRegionAndBenefit(
            this.proposalSituation.scenarios[0].carrierCurrentPlans.regions,
            this.benefit.id,
            item.carrier.id,
            this.studyConfiguration.id,
            currentPlanIds,
            this.proposalSituation.specific,
          )
          .then((response) => {
            item.plans[i].plansType = response.data;
          });
      }
    },
    setRefundsPlan(item) {
      console.log(item);
      if(!item.product || !item.product.id){
        item.consultationRefund = null;
        item.psychotherapyRefund = null;
        item.physiotherapyRefund = null;
        item.skullTomographyRefund = null;
        item.caesareanBirthRefund = null;
        item.revascularizationMyocardiumRefund = null;
        return;
      }
      if(!item.product.refunds) return;
      let consultationRefund = item.product.refunds.filter(
        (r) => r.event == 'Consulta Eletiva',
      );
      let psychotherapyRefund = item.product.refunds.filter(
        (r) => r.event == 'Sessão de Psicoterapia',
      );
      let physiotherapyRefund = item.product.refunds.filter(
        (r) => r.event == 'Fisioterapia',
      );
      let skullTomographyRefund = item.product.refunds.filter(
        (r) => r.event == 'Tomografia de Crânio',
      );
      let caesareanBirthRefund = item.product.refunds.filter(
        (r) => r.event == 'Parto Cesárea',
      );
      let revascularizationMyocardiumRefund = item.product.refunds.filter(
        (r) => r.event == 'Revascularização do Miocárdio',
      );
      item.consultationRefund = consultationRefund && consultationRefund.length>0 ? consultationRefund[0].value.toFixed(2).replace('.',',') : null;
      item.psychotherapyRefund = psychotherapyRefund && psychotherapyRefund.length>0
        ? psychotherapyRefund[0].value.toFixed(2).replace('.',',')
        : null;
      item.physiotherapyRefund = physiotherapyRefund && physiotherapyRefund.length>0
        ? physiotherapyRefund[0].value.toFixed(2).replace('.',',')
        : null;
      item.skullTomographyRefund = skullTomographyRefund && skullTomographyRefund.length>0
        ? skullTomographyRefund[0].value.toFixed(2).replace('.',',')
        : null;
      item.caesareanBirthRefund = caesareanBirthRefund && caesareanBirthRefund.length>0
        ? caesareanBirthRefund[0].value.toFixed(2).replace('.',',')
        : null;
      item.revascularizationMyocardiumRefund = revascularizationMyocardiumRefund && revascularizationMyocardiumRefund.length>0
        ? revascularizationMyocardiumRefund[0].value.toFixed(2).replace('.',',')
        : null;
    },
    getEquivalentsCarriers(linedItem,index,plan){
      console.log("Chamou getEquivalentsCarriers");
      if(!linedItem.product) return;
      this.setRefundsPlan(linedItem);
      this.findAllEquivalentCarriersByBenefitIdAndRegionAndReferencePlanId();
      this.requestEquivalentPlansByReferencePlan(
        linedItem.product.id,
        index,
        plan.product.id,
      );
    },
    getEquivalentsPlans(index,plan){
      console.log("Chamou getEquivalentsPlans");
      if(plan.product)
      this.setRefundsPlan(plan);
      his.requestEquivalentPlansByReferencePlan(
          null,
          index,
          plan.product.id,
        );
    },
    async requestEquivalentPlansByReferencePlan(
      referencePlanId,
      index,
      currentPlanId,
    ) {
      let currentPlanIds = [];
      let proposePlanIds = [];
      this.proposalSituation.scenarios[0].carrierProposedPlans
      .filter(p => !p.isReferencedCarrier)
      .forEach(p => {
        p.plans[index].linedPlans.forEach(l => {
          if(l.product && l.product.id)
            proposePlanIds.push(l.product.id);
        });
      });

      if(!referencePlanId){
        referencePlanId = this.proposalSituation.scenarios[0].carrierProposedPlans
          .filter(pp => pp.isReferencedCarrier)[0].plans[index].linedPlans[0].product.id;
      }

      for (
        var i = 0;
        i < this.proposalSituation.scenarios[0].carrierProposedPlans.length;
        i++
      ) {
        let planId = currentPlanId ? currentPlanId : null;

        currentPlanIds.splice(0);
        if (planId != null) {
          currentPlanIds.push(planId);
        }
        
        let p = this.proposalSituation.scenarios[0].carrierProposedPlans[i];
        if (
          p.carrier != null &&
          p.carrier.id != null &&
          !p.isReferencedCarrier
        ) {
          await this._equivalenceConfigurationService
            .findAllEquivalentPlansByRegionAndBenefit(
              this.proposalSituation.scenarios[0].carrierCurrentPlans.regions,
              this.benefit.id,
              p.carrier.id,
              referencePlanId,
              proposePlanIds,
              this.studyConfiguration.id,
              currentPlanIds,
              this.proposalSituation.specific
            )
            .then((response) => {
              p.plans[index].plansType = response.data;
            });
        }
      }
    },
    async requestEquivalentPlansByCarrier(item,pIndex) {
      if(!item.carrier || !item.carrier.id){
        this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.forEach((p,pIndex) => {
          item.plans[pIndex].plansType = [];
          item.plans[pIndex].linedPlans.forEach(l => {
            l.product = null;
            l.consultationRefund = null;
            l.psychotherapyRefund = null;
            l.physiotherapyRefund = null;
            l.skullTomographyRefund = null;
            l.caesareanBirthRefund = null;
            l.revascularizationMyocardiumRefund = null;
          });
        });
        return;
      }
      let currentPlanIds = [];
      this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.forEach(async (cp,cpIndex) => {
        currentPlanIds.splice(0);
        if (cp.product && cp.product.id) {
          currentPlanIds.push(cp.product.id);
        }

        let proposePlanIds = [];
        this.proposalSituation.scenarios[0].carrierProposedPlans
        .filter(p => !p.isReferencedCarrier)
        .forEach(p => {
          p.plans[cpIndex].linedPlans.forEach(l => {
            if(l.product && l.product.id)
              proposePlanIds.push(l.product.id);
          });
        });
        let rp = this.proposalSituation.scenarios[0].carrierProposedPlans.filter(p => p.isReferencedCarrier)[0];
        let referencePlanId = rp.plans[cpIndex].linedPlans[0].product ? rp.plans[cpIndex].linedPlans[0].product.id : null;

        await this._equivalenceConfigurationService
          .findAllEquivalentPlansByRegionAndBenefit(
            this.proposalSituation.scenarios[0].carrierCurrentPlans.regions,
            this.benefit.id,
            item.carrier.id,
            referencePlanId,
            proposePlanIds,
            this.studyConfiguration.id,
            currentPlanIds,
            this.proposalSituation.specific
          )
          .then((response) => {
            item.plans[cpIndex].plansType = response.data;
          });
      });
    },
    getAllCurrentPlans() {
      let currentPlanIds = [];
      this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.forEach(
        (plan) => {
          if (plan.product && plan.product.id) {
            currentPlanIds.push(plan.product.id);
          }
        },
      );
      return currentPlanIds;
    },
    getAllReferencePlans() {
      let referencePlanIds = [];
      this.proposalSituation.scenarios[0].carrierProposedPlans[0].plans.forEach(
        (plan) => {
          plan.linedPlans.forEach((linedPlan) => {
            if (linedPlan.product && linedPlan.product.id) {
              referencePlanIds.push(linedPlan.product.id);
            }
          });
        }
      );
      return referencePlanIds;
    },
    addProposalPlan(item, index) {
      if (!item.width) {
        item.width = 345;
      }
      item.width = parseInt(item.width) + 345;
      item.plans[index].linedPlans.push({
        product: {},
        consultationRefund: null,
        psychotherapyRefund: null,
        physiotherapyRefund: null,
        skullTomographyRefund: null,
        caesareanBirthRefund: null,
        revascularizationMyocardiumRefund: null,
        lives: null,
        copay: {averageCost: null},
        secondCopay: {averageCost: null},
        inactiveLives: null,
        inactiveCopay: {averageCost: null},
        inactiveSecondCopay: {averageCost: null},
        houseHoldLives: null,
        houseHoldCopay: {averageCost: null},
        houseHoldSecondCopay: {averageCost: null},
        upgradePlans: [],
        downgradePlans: [],
        ageGroupCost: [],
        inactiveAgeGroupCost: [],
        houseHoldAgeGroupCost: [],
      });
      for (let i = 0; i < 10; i++) {
        item.plans[index].linedPlans[
          item.plans[index].linedPlans.length - 1
        ].ageGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null,
        });
        item.plans[index].linedPlans[
          item.plans[index].linedPlans.length - 1
        ].inactiveAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null,
        });
        item.plans[index].linedPlans[
          item.plans[index].linedPlans.length - 1
        ].houseHoldAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null,
        });
      }
    },
    removeProposalPlan(item, index, lpi) {
      item.width = parseInt(item.width) - 345;
      item.plans[index].linedPlans.splice(lpi, 1);
    },
    copyCurrentPlan(index) {
      var copy =
        this.proposalSituation.scenarios[0].carrierCurrentPlans.plans[index];
      this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.push({
        copy: true,
        product: copy.product,
        consultationRefund: copy.consultationRefund,
        psychotherapyRefund: copy.psychotherapyRefund,
        physiotherapyRefund: copy.physiotherapyRefund,
        skullTomographyRefund: copy.skullTomographyRefund,
        caesareanBirthRefund: copy.caesareanBirthRefund,
        revascularizationMyocardiumRefund:
          copy.revascularizationMyocardiumRefund,
        lives: copy.lives,
        openAgeGroupCost: false,
        openInactiveAgeGroupCost: false,
        openHouseHoldAgeGroupCost: false,
      });
      this.addCarrierProposedPlan(0);
      this.addCarrierProposedPlan(1);
      this.addCarrierProposedPlan(2);
      this.addCarrierProposedPlan(3);
    },
    addCarrierProposedPlan(index) {
      this.proposalSituation.scenarios[0].carrierProposedPlans[
        index
      ].plans.push({
        plansType: [],
        linedPlans: [
          {
            product: {},
            consultationRefund: null,
            psychotherapyRefund: null,
            physiotherapyRefund: null,
            skullTomographyRefund: null,
            caesareanBirthRefund: null,
            revascularizationMyocardiumRefund: null,
            lives: null,
            copay: {averageCost: null},
            secondCopay: {averageCost: null},
            inactiveLives: null,
            inactiveCopay: {averageCost: null},
            inactiveSecondCopay: {averageCost: null},
            houseHoldLives: null,
            houseHoldCopay: {averageCost: null},
            houseHoldSecondCopay: {averageCost: null},
            upgradePlans: [],
            downgradePlans: [],
            ageGroupCost: [],
            inactiveAgeGroupCost: [],
            houseHoldAgeGroupCost: [],
          },
        ],
      });
      for (let i = 0; i < 10; i++) {
        this.proposalSituation.scenarios[0].carrierProposedPlans[index].plans[
          this.proposalSituation.scenarios[0].carrierProposedPlans[index].plans
            .length - 1
        ].linedPlans[0].ageGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null,
        });
        this.proposalSituation.scenarios[0].carrierProposedPlans[index].plans[
          this.proposalSituation.scenarios[0].carrierProposedPlans[index].plans
            .length - 1
        ].linedPlans[0].inactiveAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null,
        });
        this.proposalSituation.scenarios[0].carrierProposedPlans[index].plans[
          this.proposalSituation.scenarios[0].carrierProposedPlans[index].plans
            .length - 1
        ].linedPlans[0].houseHoldAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null,
        });
      }
    },
    removeCurrentPlan(index) {
      this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.splice(
        index,
        1,
      );
      this.proposalSituation.scenarios[0].carrierProposedPlans[0].plans.splice(
        index,
        1,
      );
      this.proposalSituation.scenarios[0].carrierProposedPlans[1].plans.splice(
        index,
        1,
      );
      this.proposalSituation.scenarios[0].carrierProposedPlans[2].plans.splice(
        index,
        1,
      );
      this.proposalSituation.scenarios[0].carrierProposedPlans[3].plans.splice(
        index,
        1,
      );
    },
    resetInactives() {
      if (!this.proposalSituation.showInactiveLives) {
        this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.forEach(
          (p) => {
            p.openInactiveAgeGroupCost = false;
          },
        );
        this.proposalSituation.scenarios[0].carrierProposedPlans.forEach(
          (c) => {
            c.plans.forEach((p) => {
              p.linedPlans.forEach((l) => {
                l.inactiveLives = null;
                l.inactiveCopay.averageCost = null;
                l.inactiveSecondCopay.averageCost = null;
                l.inactiveAgeGroupCost = [];
                for (let i = 0; i < 10; i++) {
                  l.inactiveAgeGroupCost.push({
                    id: i,
                    lives: null,
                    copayValue: null,
                    secondCopayValue: null,
                  });
                }
              });
            });
          },
        );
      }
    },
    resetHouseHoldies() {
      if (!this.proposalSituation.showHouseHoldLives) {
        this.proposalSituation.scenarios[0].carrierCurrentPlans.plans.forEach(
          (p) => {
            p.openHouseHoldAgeGroupCost = false;
          },
        );
        this.proposalSituation.scenarios[0].carrierProposedPlans.forEach(
          (c) => {
            c.plans.forEach((p) => {
              p.linedPlans.forEach((l) => {
                l.houseHoldLives = null;
                l.houseHoldCopay.averageCost = null;
                l.houseHoldSecondCopay.averageCost = null;
                l.houseHoldAgeGroupCost = [];
                for (let i = 0; i < 10; i++) {
                  l.houseHoldAgeGroupCost.push({
                    id: i,
                    lives: null,
                    copayValue: null,
                    secondCopayValue: null,
                  });
                }
              });
            });
          },
        );
      }
    },
  },
  name: 'include_proposal_status',
};
</script>

<style scoped></style>
